"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sendFeedback = exports.redirect = exports.history = exports.getUserType = exports.getUserId = exports.getState = exports.getServiceConfig = exports.getLocale = exports.getCookiePolicy = exports.getConnected = exports.dispatch = exports.createToast = exports.createDialog = exports.createBridge = exports.chrome = void 0;

var _penpal = _interopRequireDefault(require("penpal"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var connection;
var actions = {};
var platform = {};
var state = {
  connected: false,
  locale: 'en-GB',
  location: '/',
  cookie_policy: {
    essential: true,
    performance: false,
    marketing: false,
    functional: false
  }
};
var SERVICE_CONFIG_STORAGE_KEY = 'serviceConfig';

var warning = function warning() {
  return console.info('This application is currently not running within Media Ecosystem');
};

var createBridge = function createBridge(_ref) {
  var localeChangeHandler = _ref.localeChangeHandler,
      _ref$parentOrigin = _ref.parentOrigin,
      parentOrigin = _ref$parentOrigin === void 0 ? 'https://www.mediaecosystem.io' : _ref$parentOrigin,
      _ref$isBypassSecurity = _ref.isBypassSecurity,
      isBypassSecurity = _ref$isBypassSecurity === void 0 ? false : _ref$isBypassSecurity,
      _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? false : _ref$debug;
  sessionStorage.setItem('debug', debug);
  var appUrlSearch = window && window.location && window.location.search;

  if (appUrlSearch) {
    var urlParams = new URLSearchParams(appUrlSearch) || {};

    if (urlParams) {
      var serviceConfig = {
        clientCode: urlParams.get('clientCode') || '',
        tenantId: urlParams.get('tenantId') || ''
      };
      sessionStorage.setItem(SERVICE_CONFIG_STORAGE_KEY, JSON.stringify(serviceConfig));
    }
  }

  try {
    if (!location.hostname.endsWith('mediaecosystem.io') || isBypassSecurity) {
      connection = _penpal.default.connectToParent({});
    } else {
      connection = _penpal.default.connectToParent({
        parentOrigin: parentOrigin
      });
    }

    var ensureOnConnectRunsOnce = true;
    connection.promise.then(function (parent) {
      if (ensureOnConnectRunsOnce) {
        ensureOnConnectRunsOnce = null;
      } else {
        return;
      }

      sessionStorage.setItem('connected', true);
      state.connected = true;
      var okta_tokens = localStorage.getItem('okta-token-storage');
      parent.connected();
      parent.getUserId().then(function (result) {
        var tokens = JSON.parse(okta_tokens);
        var isSameId = tokens.idToken.claims.sub === result.userId;
        sessionStorage.setItem('user_id', result.userId);

        if (!isSameId) {
          console.error('Token Identity mis-match');
          sessionStorage.clear();
          localStorage.clear();
          location.reload();
        }
      }).catch(function (e) {
        console.error(e);
      });
      parent.getUserType().then(function (result) {
        sessionStorage.setItem('user_type', result.userType);
      }).catch(function (e) {
        console.error(e);
      });
      parent.manageToken(okta_tokens).then(function (result) {}).catch(function (e) {
        console.error(e);
      });
      window.platformRedirect = parent.redirect;
      window.platformToast = parent.toast;
      window.platformChrome = parent.chrome;
      window.platformFeedback = parent.feedback;
      setInterval(function () {
        return parent.sync().then(function (results) {
          if (debug) {
            console.log('Sync data from Platform Client', results);
          }

          sessionStorage.setItem('locale', results.locale);
          sessionStorage.setItem('cookie_policy', results.cookie_policy);
        }).then(function (results) {
          if (localeChangeHandler) {
            var currLocale = sessionStorage.getItem('locale');

            if (state.locale !== currLocale) {
              localeChangeHandler(currLocale);
              state.locale = currLocale;
            }
          }
        });
      }, 1000);
    }).catch(function (e) {
      console.error('ERROR: Bridge Security > Parent URL is not allowed');
      console.error(e);
    });
  } catch (error) {
    sessionStorage.setItem('connected', false);
    sessionStorage.setItem('locale', 'en-GB');
    sessionStorage.setItem('cookie_policy', JSON.stringify(state.cookie_policy));
    warning();
  }
};

exports.createBridge = createBridge;

var getState = function getState(key) {
  return sessionStorage.getItem(key);
};

exports.getState = getState;

var getConnected = function getConnected() {
  return JSON.parse(sessionStorage.getItem('connected')) || false;
};

exports.getConnected = getConnected;

var getCookiePolicy = function getCookiePolicy() {
  return sessionStorage.getItem('cookie_policy') ? JSON.parse(sessionStorage.getItem('cookie_policy')) : state.cookie_policy;
};

exports.getCookiePolicy = getCookiePolicy;

var getLocale = function getLocale() {
  return sessionStorage.getItem('locale') || 'en-GB';
};

exports.getLocale = getLocale;

var getClient = function getClient() {
  return console.log('Dispatch action: Work in progress');
};

var dispatch = function dispatch(_ref2) {
  var action = _ref2.action,
      payload = _ref2.payload;
  return console.log('Dispatch action: Work in progress');
};

exports.dispatch = dispatch;

var error = function error() {
  return console.log('Error action: Work in progress');
};

var history = function history() {
  return console.log('History action: Work in progress');
};

exports.history = history;

var redirect = function redirect(path) {
  var parameters = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (typeof window.platformRedirect === 'function') {
    window.platformRedirect(path, parameters);
  } else {
    console.info('Redirect cannot execute unless the application is running within Media Ecosystem');
  }
};

exports.redirect = redirect;

var createDialog = function createDialog() {
  return console.log('Create dialog action: Work in progress');
};

exports.createDialog = createDialog;

var createToast = function createToast() {
  var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (typeof window.platformToast === 'function') {
    window.platformToast(parameters);
  } else {
    console.info('createToast cannot execute unless the application is running within Media Ecosystem');
  }
};

exports.createToast = createToast;

var chrome = function chrome() {
  var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'toggle';

  if (typeof window.platformChrome === 'function') {
    window.platformChrome(mode);
  } else {
    console.info('chrome cannot execute unless the application is running within Media Ecosystem');
  }
};

exports.chrome = chrome;

var sendFeedback = function sendFeedback() {
  if (typeof window.platformFeedback === 'function') {
    window.platformFeedback();
  } else {
    console.info('sendFeedback cannot execute unless the application is running within Media Ecosystem');
  }
};

exports.sendFeedback = sendFeedback;

var getServiceConfig = function getServiceConfig() {
  var serviceConfigObject = {};

  try {
    serviceConfigObject = JSON.parse(sessionStorage.getItem(SERVICE_CONFIG_STORAGE_KEY));
  } catch (err) {
    console.error('There was some issue while retrieving serviceConfig', err);
  }

  return serviceConfigObject;
};

exports.getServiceConfig = getServiceConfig;

var getUserId = function getUserId() {
  return sessionStorage.getItem('user_id') || null;
};

exports.getUserId = getUserId;

var getUserType = function getUserType() {
  return sessionStorage.getItem('user_type') || null;
};

exports.getUserType = getUserType;